import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { FeeProcessComponent } from '../fee-process/fee-process.component';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-fees',
  templateUrl: './fees.component.html',
  styleUrls: ['./fees.component.scss']
})
export class FeesComponent implements OnInit {
  FeeForm: FormGroup;
  FeeTempletList: any;
  FeeModeList: any;
  FeeTempList: any;
  payBtnShow;
  PayBtn = true;
  PayStatus = false;
  StudentIdd: string;
  FeePaid: string;
  StuData: any;
  constId = 0;
  StudentType: '';
  StudentStatus: '';
  Constitution: '';
  Caste: '';
  ShowMsg = false;
  ApprovalCheck = false
  Message2 : string;
  FeeTable: [];
  feeApplyArray: FormArray;
  dialogRef: MatDialogRef<any>;
  xyz = sessionStorage.getItem("StuCoId");
  pqr = sessionStorage.getItem("StuCgId");
  ADMRecords: any[];
  Dates: any[];
  Message: string;
  TempMsg = false;
  updateBtn = false;
  Message3 = '';
  FeePaidstatus;
  submitpayload: any;
  constructor(private fb: FormBuilder,
    public umsService: UmsService,
    public dialog: MatDialog, private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService) { }
  FcCode = sessionStorage.getItem("faculty");
  CoCode = sessionStorage.getItem("StuCoId");
  CgCode = sessionStorage.getItem("StuCgId");
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  sessionNo = sessionStorage.getItem('session');
  collegeName
  courseName
  ngOnInit(): void {
    this.PayBtn = true;
    this.ShowMsg = false;
    this.Message = '';
    this.ApprovalCheck = false;
    this.Message2 = '';
    this.TempMsg = false;
    this.Message3 = '';
    this.PayStatus = false;
    sessionStorage.getItem("faculty");
    sessionStorage.getItem("course");
    sessionStorage.getItem("college");
    this.FeeForm = this.fb.group({

      feeApplyArray: new FormArray([]),
    })

    this.ValidateFees();

  
   
  }

  getUGCDetails(){
    this.spinner.show();
    this.submitpayload = {}
    this.submitpayload['StuId'] = sessionStorage.getItem("StudentPersonalId");
    this.umsService.getUGCDetails(this.submitpayload).subscribe((res) => {
      console.log("res in updateUGC",res);
      this.spinner.hide();
      }, (ERROR: HttpErrorResponse) => {
    //  alert(ERROR.error.message);
     this.spinner.hide();
        }
  )

  }

  getSecretData() {
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      let activeFlowObject = res.projectPharam['ActiveFlow']
        let arrActiveFlow = JSON.parse(activeFlowObject);
        if(arrActiveFlow[0]['FeesBeforeScrutiny'] == 1){
          // this.SelectAllActive = true;
          this.getFeeBeforeScrutiny();
        }
        else if(arrActiveFlow[0]['FeesBeforeScrutiny'] == 0){
          // this.SelectAllActive = false;
          this.ValidateFees();
        }
    
      
    })
  }
  ValidateFees() {
    const payload = {}
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId");
    payload['FeeType'] = 'AF';
    payload['SnNo'] = sessionStorage.getItem('session');
    this.umsService.ValidateFees(payload).subscribe(res => {
      this.getRgId();
      // this.getFeeTempData();
      this.getFeeModeData();
      this.submit();
      this.getScrutiny();

    })
  }

  getFeeModeData() {
    this.spinner.show();
    const payload = {};
    payload["Session"] = parseInt(this.sessionNo);
    payload['College'] = sessionStorage.getItem("StuCgId"),
      this.umsService.fetchCheckFeeMode(payload).subscribe(res => {
        this.FeeModeList = res.data;
        sessionStorage.setItem('FeeMode', res.data[0].FeeMode);
        this.spinner.hide();
        if (res.data[0].FeeMode == 'ONLIN') {
          this.payBtnShow = true;
        } else {
          this.payBtnShow = false;
        }
      });
  }

  getcollege(CgCode) {
    const payload = {};
    payload['CgCode'] = CgCode
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeName = res.data[0].CgName;

    }, (ERROR: HttpErrorResponse) => {
      // this.collegedataList = [];
      this.spinner.hide();
    })
  }


  getCourse(CoCode) {
    const payload = {};
    payload['CoCode'] = CoCode
    this.umsService.fetchCourseType(payload).subscribe(res => {
      this.spinner.hide();
      this.courseName = res.data[0].CoName;
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }
  getScrutiny() {
    const payload = {};
    payload['StudentId'] = sessionStorage.getItem('StudentPersonalId');
    this.umsService.fetchScrutinyLock(payload).subscribe(res => {
      if (res.status) {
        if (res.data[0]['Status'] == "APPR" && res.data[0]['FinalApproval'] == true) {
          if (res.data[0]['UserId'] == res.data[0]['ApprovedBy']) {
            this.ApprovalCheck = false;
            this.Message2 = '';
          }
          else if (res.data[0]['UserId'] != res.data[0]['ApprovedBy']) {
            this.showAlert2('Application In Process');
          }


        }
        else if (res.data[0]['Status'] == "APPR" && res.data[0]['FinalApproval'] != true) {
          this.showAlert2('Application In Process');
        }

      }
      else {
        this.showAlert2('Application In Process');
      }
    });
  }

  showAlert2(message: string) {
    // let data = {
    //   message: message,
    //   title: 'Alert',
    //   icon: 'fas fa-close'
    // };
    // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
    this.ApprovalCheck = true
    this.Message2 = message;
  }

  submit() {
    let payload = {};
    this.ADMRecords = [];
    this.Dates = [];
    payload['SnNo'] = parseInt(this.sessionNo);
    payload['InCode'] = 'ADFEE'
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['CoCode'] = sessionStorage.getItem("StuCoId");
    this.umsService.CheckValidDate(payload).subscribe(res => {
      if (res.status) {
        const courseRecords = res.data.filter(record => record.CoCgCoCode === sessionStorage.getItem("StuCoId") && record.CoCgCgCode === sessionStorage.getItem("StuCgId"));
        const today = new Date();
        const todayDateString = today.toISOString().split('T')[0];

        if (courseRecords.length > 0) {
          this.ADMRecords = courseRecords.filter(record => record.InCode === 'ADFEE');
        }

        let listCanOpen = false;
        if (this.ADMRecords.length == 0) {
          this.showAlert('Schedule Not Open For This Activity');
          listCanOpen = false;
        }
        else if (this.ADMRecords.length > 0) {
          for (let item of this.ADMRecords) {
            if ((item.FromDate.split('T')[0] === todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString == item.ToDate.split('T')[0])) {
              listCanOpen = true;
              break;
            }
          }
        }

        if (!listCanOpen) {
          for (let item of this.ADMRecords) {
            if (todayDateString > item.ToDate.split('T')[0]) {
              this.showAlert('Admission Fee Payment Dates Are Closed For This Course');
              break;
            } else if (todayDateString < item.FromDate.split('T')[0]) {
              this.showAlert('Schedule Is Not Open For This Activity');
              break;
            }
          }
        }
        if (listCanOpen == true) {
          this.ShowMsg = false;
          this.Message = '';
        }
      } else {
        this.showAlert('Schedule Is Not Open For This Activity');
      }
    });

  }

  

  showAlert(message: string) {
    // let data = {
    //   message: message,
    //   title: 'Alert',
    //   icon: 'fas fa-close'
    // };
    // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
    this.ShowMsg = true
    this.Message = message;
  }

  getFeeTempData() {
    this.spinner.show();
    const payload = {};
    payload['SessionId'] = this.sessionNo,
      payload['CoCode'] = sessionStorage.getItem("StuCoId");
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['StuId'] = this.StudentPersonalId;
    payload['FeeType'] = 'AF';
    this.umsService.SearchFeeAdm(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.TempMsg = false;
        this.Message3 = '';
        // this.Table = true;
        this.getFeeModeData();
        this.FeeTable = res.data;
        this.CgCode = res.data[0].CgCode
        this.CoCode = res.data[0].CoCode
        this.getcollege(this.CgCode)
        this.getCourse(this.CoCode)
        sessionStorage.setItem('Currency', res.data[0].Currency)
        // this.studentId = res.data.StuId;
        this.FeeTable.forEach((element, i) => {
          const creds = this.FeeForm.controls.feeApplyArray as FormArray;
          creds.push(
            this.fb.group({
              StudentName: new FormControl(element['StuFirstNameEng'] + " " + element['StuMidNameEng'] + " " + element['StuLastNameEng']),
              TemplateName: new FormControl(element['TemplateName']),
              StuType: new FormControl(),
              StuStatus: new FormControl(),
              StuSocial: new FormControl(),
              StuAdm: new FormControl(),
            })
          );
          this.getStudentType(element['StudentType'], i)
          this.getStudentStatus(element['StudentStatus'], i);
          this.getSocial(element['SocialReservation'], i);
          // this.getConstitution(element['constitutional'],i);
          this.getAdmission(element['AdmissionMode'], i);
          // this.getCaste(element['Caste'],i);
          this.StudentIdd = sessionStorage.getItem("StudentPersonalId");
          this.SearchFeeDetails(res.data[0]['TemplateCode'], this.StudentIdd)
        });
      } else {
        this.spinner.hide();
        if (res.message == 'No Data Found') {
          // this.Table = false;
          this.FeeTable = [];
          this.TempMsg = true;
          this.Message3 = 'Template Not Defined For This Criteria';
          this.ShowMsg = false;
          this.Message = ''
        }

      }
    });
  }

  SearchFeeDetails(TempCode, StdId) {
    this.spinner.show();
    const payload = {};
    // payload['TemplateCode'] =  this.tempCo;
    payload['FeeTemplateCode'] = TempCode;
    payload['StuId'] = StdId;
    payload['FeeHistory'] = 0;
    payload['SnNo'] = this.sessionNo
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        let data = 0
        res.data.forEach(element => {
          data += element.FeeAmt
        });
        if (res.data[0]['TotalPaidAmount'] == 0) {
          this.updateBtn = true;
          this.PayBtn = false;
          this.PayStatus = true;
          this.FeePaid = 'Wave Off'
          this.FeePaidstatus = 'Waved Off'
        }
        else if (data == res.data[0]['TotalPaidAmount']) {
          this.PayBtn = false;
          this.PayStatus = true;
          this.FeePaid = 'Fees Paid'
          this.FeePaidstatus = 'Payment Status'
        }
        else if (data != res.data[0]['TotalPaidAmount']) {
          this.PayBtn = true;
          this.PayStatus = false;
        }

        if(this.PayStatus == true){
          this.getUGCDetails();
        }


      } else {

      }
    });

  }

  getfeeApplyArrayControls() {
    return (this.FeeForm.get('feeApplyArray') as FormArray).controls;
  }


  openFeeProcessPopUp(item) {
    // localStorage.clear();
    sessionStorage.setItem('TemplateCode', item.TemplateCode);
    const dialogRef4 = this.dialog.open(FeeProcessComponent,
      {
        disableClose: true,
        width: "900px",
        height: "400px",
        panelClass: 'custom-dialog-container',
        data:this.CgCode
      });
    dialogRef4.afterClosed().subscribe((result) => {
      this.ngOnInit();
    });
  }


  getStudentType(id, i) {
    const payload = {};
    payload['CdType'] = 'STYPE'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.StuData = res.data
        this.feeApplyArray = this.FeeForm.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuType').setValue(element['CdDesc']);
        });
      }
    });
  }

  getStudentStatus(id, i) {
    const payload = {};
    payload['CdType'] = 'STUST'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.StuData = res.data
        this.feeApplyArray = this.FeeForm.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuStatus').setValue(element['CdDesc']);
        });
      }
    });
  }

  getSocial(id, i) {
    const payload = {};
    payload['CdType'] = 'SR'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.StuData = res.data
        this.feeApplyArray = this.FeeForm.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuSocial').setValue(element['CdDesc']);
        });
      }
    });
  }

  getAdmission(id, i) {
    const payload = {};
    payload['CdType'] = 'AMODE'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.StuData = res.data
        this.feeApplyArray = this.FeeForm.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuAdm').setValue(element['CdDesc']);
        });
      }
    });
  }


  addnewrecord(item) {

    sessionStorage.setItem('TemplateCode', item.TemplateCode);
    let data = {};
    data['SnNo'] = this.sessionNo
    data['TemplateCode'] = item.TemplateCode
    const dialogRef = this.dialog.open(PaymentReceiptComponent, {
      width: '80vh',
      // height: '80vh',
      data,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  getRgId() {
    const payload = {};
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId");;
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        this.examform(res.data[0]['RgId'])
      }
      else {
        this.getFeeTempData();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.getFeeTempData();
    })
  }

  examform(RgId) {
    const payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    this.umsService.fetchLatestEcid(payload)
      .subscribe((res) => {
        if (res.status) {
          if (res.data[0]['EmSrNo'] > 1) {
            this.FeeTable = [];
            this.TempMsg = true;
            this.Message3 = 'Fees Already Paid';
          }
          else if (res.data[0]['EmSrNo'] == 1) {
            this.getFeeTempData();
          }

        } else {
          this.getFeeTempData();
        }

      }, (ERROR: HttpErrorResponse) => {
        this.getFeeTempData();
      });

  }


  getFeeBeforeScrutiny() {
    const payload = {};
    payload['SessionId'] = this.sessionNo,
    payload['CoCode'] = sessionStorage.getItem("StuCoId");
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['StuId'] = this.StudentPersonalId;
    payload['FeeType'] = 'AF';
    this.umsService.payBeforeScrutiny(payload).subscribe((res) => {
      if (res.status) {
        this.FeeTable = res.data;
        this.CgCode = res.data[0].CgCode
        this.CoCode = res.data[0].CoCode
        this.getcollege(this.CgCode)
        this.getCourse(this.CoCode)
        this.getFeeModeData();
        sessionStorage.setItem('Currency', res.data[0].Currency)
        // this.studentId = res.data.StuId;
        this.FeeTable.forEach((element, i) => {
          const creds = this.FeeForm.controls.feeApplyArray as FormArray;
          creds.push(
            this.fb.group({
              StudentName: new FormControl(element['StuFirstNameEng'] + " " + element['StuMidNameEng'] + " " + element['StuLastNameEng']),
              TemplateName: new FormControl(element['TemplateName']),
              StuType: new FormControl(),
              StuStatus: new FormControl(),
              StuSocial: new FormControl(),
              StuAdm: new FormControl(),
            })
          );
          this.StudentIdd = sessionStorage.getItem("StudentPersonalId");
          this.SearchFeeDetails(res.data[0]['TemplateCode'], this.StudentIdd)
        });
      }
      else {

      }
    }, (ERROR: HttpErrorResponse) => {

    })
  }

}
